<template>
  <router-view />
</template>

<script>
  export default {
    name: 'TrackingLayout'
  }
</script>